import { AuthenticatedLayout } from "../../../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { TrustBankSetup } from "../../../../components/DirectDeposit/TrustBank/TrustBankSetup";

export const TrustBankSetupPage = () => {
    return (
        <AuthenticatedLayout
            pageTitle=""
            pageTitleIcon={<DescriptionOutlinedIcon />}
            breadcrumbCurrentPageName=""
            breadcrumbLinks={[]}
            mainContents={<TrustBankSetup />}
        />
    );
};
